var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.createdAt))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.log.event))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.log.message))]),_vm._v(" "),_c('td',_vm._l((_vm.log.details),function(detail,index){return _c('p',{key:index},[_vm._v("\n      "+_vm._s(detail)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }